export default __webpack_public_path__ + "static/media/modal_2_pet_mobile.3ab12a42.svg";